import { FC } from 'react';
import SendDocumentTable from '@modules/documents/children/sent/components/send-document-table';

const ILSDocumentsSent: FC = () => {
  return <SendDocumentTable />;
};

export default ILSDocumentsSent;
